import IconButton from '../IconButton'
import {
    faAlignCenter,
    faAlignLeft,
    faAlignRight,
} from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import styles from './TextAlignInput.module.css'
import cx from 'classnames'

type TextAlignInputProps = {
    property: string
    value: string | undefined
    className?: string
    style?: React.CSSProperties
    onChange: (property: string, value: string) => void
}

const TextAlignInput: React.FC<TextAlignInputProps> = ({
    property,
    className,
    style,
    value,
    onChange,
}) => {
    return (
        <div
            className={cx(styles['wrapper-container'], className)}
            style={style}
        >
            <IconButton
                style={{
                    background: value === 'left' ? '#F1F1F1' : 'transparent',
                }}
                classes={cx(styles['button-item'])}
                icon={faAlignLeft}
                color={'#525252'}
                onClick={() => onChange(property, 'left')}
            />
            <IconButton
                style={{
                    background: value === 'center' ? '#F1F1F1' : 'transparent',
                }}
                classes={cx(styles['button-item'])}
                icon={faAlignCenter}
                color={'#525252'}
                onClick={() => onChange(property, 'center')}
            />
            <IconButton
                style={{
                    background: value === 'right' ? '#F1F1F1' : 'transparent',
                }}
                classes={cx(styles['button-item'])}
                icon={faAlignRight}
                color={'#525252'}
                onClick={() => onChange(property, 'right')}
            />
        </div>
    )
}

export default TextAlignInput
